<template>
  <Legenda titulo="Atualizar carrinho" legenda="Atualizar a quantidade e preço desse produto no carrinho de compras">
    <v-btn icon @click="atualizarItem">
      <v-icon>
        mdi-cart-arrow-right
      </v-icon>
    </v-btn>
  </Legenda>
</template>

<script>
import { mapMutations } from 'vuex';
import { atualizarQuantidadePrecoCarrinho } from "../CotacaoApi";
import Legenda from "@/components/produto/detalhes/Legenda";

export default {
  components: {Legenda},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      SET_ATUALIZAR_CARRINHO_COMPRAS: "CotacaoCarrinhoCompra/SET_ATUALIZAR_CARRINHO_COMPRAS"
    }),
    atualizarItem() {
      const parametros = {
        idpedido: this.item.idpedido,
        idproduto: this.item.idproduto,
        qtde_pedido: this.item.quantidade,
        preco_custo: this.item.preco
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        atualizarQuantidadePrecoCarrinho(parametros)
          .then(() => this.SET_ATUALIZAR_CARRINHO_COMPRAS())
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>
